import { styled, YStack, Text, GetProps, Input as TamaguiInput } from 'tamagui'
import { useId } from 'react'

const InputFrame = styled(TamaguiInput, {
  name: 'Input',
  
  // Base styles
  backgroundColor: 'transparent',
  borderWidth: 0,
  borderBottomWidth: 2,
  borderColor: '$borderColor',
  borderRadius: 0,
  color: '$color',
  paddingHorizontal: 0,
  paddingVertical: '$2',
  width: '100%',
  
  focusStyle: {
    borderColor: '$accent',
  },
  
  placeholderTextColor: '$colorMuted',
})

const Label = styled(Text, {
  name: 'InputLabel',
  fontSize: 11,
  fontWeight: '600',
  textTransform: 'uppercase',
  letterSpacing: 1,
  color: '$colorMuted',
  marginBottom: '$1',
})

const ErrorText = styled(Text, {
  name: 'InputError',
  fontSize: 12,
  color: '$error',
  marginTop: '$1',
})

type InputFrameProps = GetProps<typeof InputFrame>

export interface InputProps extends InputFrameProps {
  label?: string
  error?: string
}

export function Input({ label, error, id, ...props }: InputProps) {
  const generatedId = useId()
  const inputId = id || generatedId

  return (
    <YStack width="100%">
      {label && <Label>{label}</Label>}
      <InputFrame
        id={inputId}
        borderColor={error ? '$error' : '$borderColor'}
        aria-invalid={error ? 'true' : undefined}
        {...props}
      />
      {error && <ErrorText>{error}</ErrorText>}
    </YStack>
  )
}

Input.displayName = 'Input'
